import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';

import Checkbox       from 'app/components/common/checkbox';
import EllipsisMenu   from 'app/components/common/ellipsis-menu';
import Modal          from 'app/components/common/modal';
import IntsDuck       from 'app/ducks/company-admin/integrations';

class ModalNylasGrant extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      defaultId: props.company.defaultNylasCalendarId,
      calChangeMap: {},
    };

    this.onClose = this.onClose.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
  }

  componentDidMount() {
    this.props.loadCalendars();
  }

  onClose() {
    this.props.onClose();
  }

  onChangeEnabled(cal, event) {
    const disabled = !event.target.checked;
    this.setState((prevState) => {
      const changes = {...(prevState.calChangeMap[cal.id] || {})};
      changes.disabled = disabled;
      return {
        calChangeMap: {
          ...prevState.calChangeMap,
          [cal.id]: changes,
        }
      }
    });
  }

  onClickMakeDefault(cal, event) {
    event.preventDefault();
    this.setState({defaultId: cal.id});
  }

  onClickSave() {
    this.props.updateCalendars(this.saveAttrs).then(() => {
      this.onClose();
    });
  }

  get saveAttrs() {
    const attrs = {};
    const {defaultId, calChangeMap} = this.state;
    if (this.props.company.defaultNylasCalendarId !== defaultId) {
      attrs.defaultId = defaultId;
    }
    if (Object.keys(calChangeMap).length) {
      attrs.calChangeMap = calChangeMap;
    }
    return attrs;
  }

  get grantCals() {
    return (this.props.allCals || []).filter(cal => cal.nylasGrantId === this.props.nylasGrant?.id);
  }

  get btnLabel() {
    return this.props.isSaving ? 'Saving...' : 'Save Changes';
  }
  get btnDisabled() {
    if (!Object.keys(this.saveAttrs).length) return true;
    if (this.props.isSaving) return true;
    return false;
  }

  render() {
    const chipConClass = '_flex _align-center _gap-6 _justify-start';

    return (
      <Modal onClose={this.onClose} className="bform">
        <h1 className="bform-h1">Manage Calendars</h1>
        <p>Campaign & event organizers will be able to sync their events to the calendars enabled below.</p>

        <div className="_border _border-bottom _mt-24">
          {this.grantCals.map((cal) => {
            const changes = this.state.calChangeMap[cal.id] || {};
            const disabled = (() => {
              if (cal.readOnly) return true;
              if (cal.deleted) return true;
              if (_.isBoolean(changes.disabled)) return changes.disabled;
              return cal.disabled;
            })();
            const canDisable = !(cal.readOnly || cal.deleted);
            const isDefault = cal.id === this.state.defaultId;
            const canDefault = (() => {
              if (cal.readOnly) return false;
              if (cal.deleted) return false;
              if (disabled) return false;
              if (isDefault) return false;
              return true;
            })();
            return (
              <div key={cal.id} className="_border _border-top  _py-24">
                <div className="_flex _gap-12 _align-center _justify-start">
                  <Checkbox checked={!disabled} onChange={this.onChangeEnabled.bind(this, cal)} isToggle offOk disabled={!canDisable} />
                  <div className={`${chipConClass} _flex-1`}>
                    <span className="_fw-bold">{cal.title}</span>
                    {isDefault && <span className="chip small blue">Default</span>}
                  </div>
                  {canDefault && (
                    <EllipsisMenu>
                      <a href="#" onClick={this.onClickMakeDefault.bind(this, cal)}>Make default</a>
                    </EllipsisMenu>
                  )}
                </div>
                {cal.readOnly && (<div className={`${chipConClass} _mt-12 _ml-60`}>
                  <span className="chip small danger">Read Only</span>
                  <span className="_fs-12 _italic">The integration user has read-only access to this calendar.</span>
                </div>)}
                {cal.deleted && (<div className={`${chipConClass} _mt-12 _ml-60`}>
                  <span className="chip small danger">Deleted</span>
                  <span className="_fs-12 _italic">This calendar is no longer accessible.</span>
                </div>)}
              </div>
            );
          })}
        </div>
    
        <div className="bform-actions">
          <div className="bform-actions-right">
            <button className="btn blue" onClick={this.onClickSave} disabled={this.btnDisabled}>{this.btnLabel}</button>
          </div>
        </div>    
      </Modal>
    );
  }

}

ModalNylasGrant.propTypes = {
  company: PropTypes.object.isRequired,
  nylasGrant: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};
ModalNylasGrant.defaultProps = {
};

const stateToProps = (state) => ({
  allCals: IntsDuck.Slx.nylasCalendars(state),
  isSaving: IntsDuck.Slx.nylasUpdatePending(state),
});
const dispatchToProps = (dispatch, ownProps) => ({
  loadCalendars: () => dispatch(IntsDuck.Ax.loadCalendars(undefined, {forceSync: true})),
  updateCalendars: (params) => dispatch(IntsDuck.Ax.updateCalendars(undefined, ownProps.nylasGrant.id, params)),
});

export default connect(stateToProps, dispatchToProps)(ModalNylasGrant);
